import type { Intent, MonsterState } from '@ml/core';

/** Icon intent theo hiệu ứng (key `intent.*` của skin). */
export function intentIcons(intent: Intent): string[] {
  const out: string[] = [];
  for (const e of intent.effects) {
    let k: string | null = null;
    if (e.type === 'attack') k = (e.hits ?? 1) > 1 ? 'multiAttack' : 'attack';
    else if (e.type === 'lockOrbs') k = 'lock';
    else if (e.type === 'freezeOrbs') k = 'freeze';
    else if (e.type === 'deadMark') k = 'deadMark';
    else if (e.type === 'destroyOrbs') k = 'destroy';
    else if (e.type === 'heal') k = 'heal';
    if (k && !out.includes(k)) out.push(k);
  }
  return out.slice(0, 2);
}

/** Sát thương dự kiến của intent (trước phòng thủ hero), 0 nếu intent không đánh. */
export function intentDamage(m: Pick<MonsterState, 'atk'>, intent: Intent): number {
  let d = 0;
  for (const e of intent.effects) {
    if (e.type === 'attack') d += Math.floor((m.atk * e.powerPct) / 100) * (e.hits ?? 1);
  }
  return d;
}
